export const getOptionCode=option=>option?.code??option.id;export const getOptionName=option=>option?.name??option.displayName;